import { useRef, useState, useContext, useEffect } from "react";
import ExperienceContext from "./ExperienceContext";
import { useSelector } from "react-redux";
import {
	showErrorNotification,
	showSuccessNotification,
} from "../../utils/Notifications";
import {
	Image,
	Group,
	Button,
	Modal,
	Tabs,
	Input,
	Container,
	TextInput,
	Loader,
	Text,
	Grid,
	ScrollArea,
	Pagination,
} from "@mantine/core";
import uploadIcon from "../../static/svg/upload.svg";
import uploadMedia from "../../API/uploadMedia";
import { getAssets } from "../../API/getAssets";
import videoIMG from "../../static/svg/video-plane.svg";
function VideoPlaneModal({
	isVideoPlaneOpen,
	setIsVideoPlaneOpen,
	activePanoId,
}) {
	const user = useSelector((state) => state.userInformationReducer.users);
	const { addNewVideoPlane } = useContext(ExperienceContext);
	const fileInput = useRef(null);
	const videoTag = useRef(null);
	const [uploadedFile, setUploadedFile] = useState(null);
	const [recentVideos, setRecentVideos] = useState("");
	const [pages, setPages] = useState(1);
	const [activePage, setPage] = useState(1);
	const [activeTab, setActiveTab] = useState("Upload");
	const [name, setName] = useState("");
	const [loading, setLoading] = useState(false);
	const handleFileUpload = (event) => {
		setUploadedFile(event.target.files[0]);
	};
	const handleCreate = async () => {
		if (name === "") {
			showErrorNotification("Name can not be empty.");
			return;
		}
		if (!uploadedFile) {
			showErrorNotification("Please upload a video first.");
			return;
		}
		setLoading(true);
		const formData = new FormData();
		formData.append("myfile", uploadedFile);
		formData.append(
			"bodyData",
			JSON.stringify({
				UserId: user?.UserId,
				AccountId: user?.AccountId,
				Name: name,
				AssetTypeId: 6,
			})
		);
		const result = await uploadMedia(formData);

		if (result.status === 201) {
			addNewVideoPlane(
				activePanoId,
				result.data.res,
				name,
				videoTag.current.videoWidth,
				videoTag.current.videoHeight
			);
			showSuccessNotification("Video uploaded");
		} else {
			showErrorNotification("Video not uploaded");
		}
		setName("");
		setUploadedFile(null);
		setIsVideoPlaneOpen(false);
		setLoading(false);
	};

	useEffect(() => {
		const recentMedia = async () => {
			const result = await getAssets(user?.UserId, activePage, 1, 10);
			setRecentVideos(result.data);
			setPages(result.totalPages);
		};
		recentMedia();
	}, [activePage]);
	return (
		<Modal
			centered
			size="lg"
			opened={isVideoPlaneOpen}
			onClose={() => {
				setName("");
				setUploadedFile(null);
				setIsVideoPlaneOpen(false);
			}}
			title="Add Video"
			styles={{
				modal: { backgroundColor: "#040F1F" },
				title: { color: "#ffffff", fontWeight: "700" },
			}}
		>
			{loading && (
				<div className="LoadingModal">
					<Loader className="LoadingModal_loader" />
				</div>
			)}
			<Tabs
				value={activeTab}
				onTabChange={setActiveTab}
				style={{ borderBottom: "none !important" }}
				styles={{
					tabsListWrapper: { borderBottom: "none !important" },
					tabsList: { borderBottom: "none !important" },
				}}
			>
				<Tabs.List>
					<Tabs.Tab
						value="Upload"
						sx={{
							"&:hover": {
								backgroundColor: "inherit",
								borderBottom: "none",
							},
						}}
					>
						Upload
					</Tabs.Tab>
					<Tabs.Tab
						value="Recent"
						sx={{
							"&:hover": {
								backgroundColor: "inherit",
								borderBottom: "none",
							},
						}}
					>
						Recent
					</Tabs.Tab>
				</Tabs.List>
				<Tabs.Panel value="Upload" pt="xs">
					<Container style={{ width: "100%", minHeight: "300px" }}>
						<TextInput
							my={5}
							label="Video Name"
							variant="filled"
							placeholder="Enter video name"
							styles={{
								input: {
									backgroundColor: "#040F1F",
									border: "1px solid #09254E",
								},
								label: {
									color: "#ffffff",
									fontWeight: "700",
								},
							}}
							value={name}
							onChange={(event) =>
								setName(event.currentTarget.value)
							}
						/>
						{uploadedFile === null ? (
							<>
								<label
									htmlFor="file-input"
									style={{
										display: "flex",
										width: "100%",
										height: "100%",
										minHeight: "300px",
										alignItems: "center",
										justifyContent: "center",
										flexDirection: "column",
										gap: "10px",
										border: "1px solid #09254E",
										borderRadius: "5px",
										cursor: "pointer",
									}}
								>
									<Image src={uploadIcon} width={75} />
									<Button
										variant="outline"
										my={10}
										px={30}
										size="xs"
										radius={"md"}
										sx={(theme) => ({
											color: theme.colors.white[0],
											borderColor:
												theme.colors.ivisit_light[0],
										})}
										onClick={() => {
											fileInput.current.click();
										}}
									>
										Browse
									</Button>
								</label>
								<Input
									id="file-input"
									ref={fileInput}
									type="file"
									accept=".mp4"
									variant="unstyled"
									styles={{
										wrapper: {
											display: "none",
										},
									}}
									onChange={handleFileUpload}
								/>
							</>
						) : (
							<video ref={videoTag} width="100%" controls>
								<source
									src={URL.createObjectURL(uploadedFile)}
									type="video/mp4"
								/>
								Your browser does not support the video tag.
							</video>
						)}
					</Container>
				</Tabs.Panel>
				<Tabs.Panel value="Recent" pt="xs">
					Use recent videos
					<ScrollArea
						mt={10}
						style={{ height: 300 }}
						type="auto"
						offsetScrollbars
						scrollbarSize={8}
						scrollHideDelay={500}
					>
						<Grid style={{ minHeight: 270 }}>
							{recentVideos &&
								recentVideos.map((item) => {
									return (
										<Grid.Col span={3} key={item.id}>
											<a
												style={{
													cursor: "pointer",
													display: "flex",
													flexDirection: "column",
												}}
											>
												<img
													alt="RecentVideos"
													style={{
														width: "20%",
														height: "80px",
														margin: "auto",
													}}
													src={videoIMG}
												/>
												<p
													style={{
														textAlign: "center",
														textOverflow:
															"ellipsis",
														whiteSpace: "nowrap",
														fontSize: "14px",
														marginTop: "3px",
														overflow: "hidden",
													}}
												>
													{`${item.Name}.mp4`}
												</p>
											</a>
										</Grid.Col>
									);
								})}
						</Grid>
						{pages !== 1 && (
							<Pagination
								sx={{
									Button: {
										background: "#09254E",
										fontWeight: "600",
										padding: "0px 4px",
										fontSize: "12px",
										border: "none",
									},
									"Button:first-child": {
										backgroundColor: "#14B8E1",
										border: "none",
									},
									"Button:last-child": {
										backgroundColor: "#14B8E1",
										border: "none",
									},
								}}
								page={activePage}
								onChange={setPage}
								mt={5}
								total={pages}
								size="xs"
								style={{
									justifyContent: "center",
									color: "pink",
								}}
							/>
						)}
					</ScrollArea>
				</Tabs.Panel>
			</Tabs>
			<Group style={{ width: "100%", justifyContent: "space-between" }}>
				<Group
					style={{
						width: "auto",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
						color: "#a4bac6",
						opacity: "0.5",
					}}
				>
					<Text
						size="xs"
						color="white"
						style={{ lineHeight: "0px", marginTop: "15px" }}
					>
						{" "}
						Make sure your file size is under 3 MB.
					</Text>
					<Text size="xs" color="white" style={{ lineHeight: "0px" }}>
						Learn More about our platform supported formats and
						restrictions.
					</Text>
				</Group>
				<Group
					style={{
						width: "auto",
						display: "flex",
						justifyContent: "space-between",
					}}
				>
					<Button
						variant="outline"
						my={0}
						px={25}
						size="xs"
						radius={"md"}
						sx={(theme) => ({
							color: theme.colors.white[0],
							borderColor: theme.colors.ivisit_light[0],
						})}
						onClick={() => {
							setIsVideoPlaneOpen(false);
							setName("");
							setUploadedFile(null);
						}}
					>
						Cancel
					</Button>
					<Button
						variant="outline"
						my={0}
						px={25}
						size="xs"
						radius={"md"}
						sx={(theme) => ({
							color: theme.colors.white[0],
							borderColor: theme.colors.ivisit_light[0],
						})}
						onClick={handleCreate}
					>
						Create
					</Button>
				</Group>
			</Group>
		</Modal>
	);
}

export default VideoPlaneModal;
